import React from "react";
import { Box } from "@mui/material";

const LinkPaymentMethod = () => (
  <Box
    component="span"
    display="inline-flex"
    alignItems="center"
    gap={0.5}
    sx={{
      color: "#005D46",
      fontWeight: 700,
      whiteSpace: "nowrap",
      verticalAlign: "middle",
    }}
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <path d="M3 5h6l5 5-5 5H3l5-5-5-5Z" fill="currentColor" />
    </svg>
    Link
  </Box>
);

export default LinkPaymentMethod;
